import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Heart, Eye } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useToast } from '../hooks/use-toast';

import SmartImage from './SmartImage';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const { toast } = useToast();

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, 1);
    toast({ title: 'Added to Basket', description: product.title.slice(0, 50) + '...' });
  };

  return (
    <div className="group relative bg-white border border-neutral-200 hover:border-[#b8892d] transition-all duration-300 hover:shadow-lg">
      <Link to={`/product/${product.id}`} className="block">
        <div className="relative overflow-hidden aspect-square bg-neutral-50">
          <SmartImage
            src={product.image}
            alt={product.title}
            className="group-hover:scale-110 transition-transform duration-700"
          />
          {product.discount > 0 && (
            <span className="absolute top-3 left-3 bg-[#b8892d] text-white text-[11px] font-semibold px-2 py-1 tracking-wide z-10">
              -{product.discount}% SALE
            </span>
          )}
          <div className="absolute top-3 right-3 flex flex-col gap-2 opacity-0 group-hover:opacity-100 transition-opacity z-10">
            <button className="w-9 h-9 bg-white text-neutral-700 hover:text-[#b8892d] shadow-md flex items-center justify-center rounded-full transition-colors" onClick={(e) => { e.preventDefault(); }}>
              <Heart size={16}/>
            </button>
            <button className="w-9 h-9 bg-white text-neutral-700 hover:text-[#b8892d] shadow-md flex items-center justify-center rounded-full transition-colors">
              <Eye size={16}/>
            </button>
          </div>
        </div>
        <div className="p-4">
          <div className="text-[11px] text-[#b8892d] uppercase tracking-widest mb-1.5 font-medium">{product.category}</div>
          <h3 className="text-sm font-medium text-neutral-800 line-clamp-2 min-h-[2.5rem] group-hover:text-[#b8892d] transition-colors">
            {product.title}
          </h3>
          <div className="flex items-baseline gap-2 mt-2 mb-3">
            <span className="text-neutral-400 line-through text-xs">₹{product.price.toLocaleString('en-IN')}</span>
            <span className="text-[#b8892d] font-semibold text-base">₹{product.sale.toLocaleString('en-IN')}</span>
          </div>
          <button
            onClick={handleAdd}
            className="w-full bg-[#1a1a1a] hover:bg-[#b8892d] text-white py-2.5 text-xs font-semibold tracking-widest uppercase transition-colors duration-300 flex items-center justify-center gap-2"
          >
            <ShoppingBag size={14}/> Add to Basket
          </button>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
